import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { sanitize } from 'dompurify';
import { Icon } from 'bv-components';

const collapsedTextLength = 200;

const ExpandableParagraph = ({ text }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <p onClick={() => { setExpanded(!expanded); }}>
      <span
        dangerouslySetInnerHTML={{
          __html: sanitize(expanded ? text : `${text.slice(0, collapsedTextLength)}...`),
        }}
      />
      <Icon className="expand-button" id={`arrow-solid-circle-${expanded ? 'up' : 'down'}`} />
    </p>
  );
};

ExpandableParagraph.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ExpandableParagraph;
